/**
 * 课程组教研室api
 */
import { getFetch } from '@/plugins/http'
import { postFetch } from '@/plugins/http'

// const baseHost = '//127.0.0.1'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /**
   * 课程组-列表
   */
  getCourseGroupList(params, config) {
    return getFetch(`${baseHost}/common/api/34-jiaoyanshi_list/portal_bk_course_group`, params, config)
  },
  /**
   * 课程组-详情
   */
  getCourseGroupDetail(params, config) {
    return getFetch(`${baseHost}/common/api/32-info/portal_bk_course_group`, params, config)
  },
  /**
   * 课程组-详情页-栏目列表
   */
  getGroupMenuList(params, config) {
    return getFetch(`${baseHost}/common/api/33-column_list/portal_bk_course_group`, params, config)
  },
  /**
   * 课程组-栏目批量详情
   */
  getColunmDetails(params, config) {
    return getFetch(`${baseHost}/common/api/33-batch_column_info/portal_kcsz_center`, params, config)
  },
  /**
   * 课程组-团队成员列表
   */
  getGroupTeamList(params, config) {
    return getFetch(`${baseHost}/common/api/33-member_list/portal_bk_course_group`, params, config)
  },
  /**
   * 课程组-团队成员详情
   */
  getGroupMemberDetail(params, config) {
    return getFetch(`${baseHost}/common/api/32-member_info/portal_bk_course_group`, params, config)
  },
  /**
   * 课程组全部我的
   */
  getAllCourseGroup(params, config) {
    return getFetch(`${baseHost}/common/api/33-bk_course_group_list/teachingCentret`, params, config)
  },
  /**
   * 教研中心-虚拟教研室-管理-列表
   */
  getTeachingRoomList(params, config) {
    return getFetch(`${baseHost}/common/api/34-manage_list/page_jiaoyanshi`, params, config)
  },
  //  课程组 教研室栏目列表
  getTeachingGroupColumnList(parme, config) {
    return getFetch(`${baseHost}/common/api/33-template_column_list/bk_course_group`, parme, config)
  },
  //  网站-栏目-详情v2
  getColumnInfoV2(parme, config) {
    return getFetch(`${baseHost}/common/api/33-column_info_v2/general_website`, parme, config)
  },
  // 查询全部专业_列表
  getAllMajorList(parme, config) {
    return getFetch(`${baseHost}/common/api/33-common_list/general_dict?business_name=major_list`, parme, config)
  },
  // 教研室课程组修改
  updateTeachingGroup(parme, config) {
    return postFetch(`${baseHost}/common/api/20-upd/bk_course_group`, parme, config)
  },
  // 教研室成员总数
  getMemberTotalNum(parme, config) {
    return getFetch(`${baseHost}/common/api/32-member_total_num/portal_bk_course_group`, parme, config)
  },
  // 所在教研室
  getMyJiaoyanshiIds(parme, config) {
    return getFetch(`${baseHost}/common/api/33-my_jiaoyanshi_ids/portal_bk_course_group`, parme, config)
  },
  // 用户申请加入教研室列表
  getApplyTeachingGroupList(parme, config) {
    return getFetch(`${baseHost}/common/api/33-getApplyForList/userApplyForTeachingGroup`, parme, config)
  },
  // 用户申请加入教研室
  applyTeachingGroup(parme, config) {
    return postFetch(`${baseHost}/common/api/10-saveApplyFor/userApplyForTeachingGroup`, parme, config)
  },
  // 申请审核链接
  getApplyTeachingGroupUrl(parme, config) {
    return getFetch(`${baseHost}/common/api/32-getApplyJumpUrl/userApplyForTeachingGroup`, parme, config)
  },
}
